import { useState } from 'react';
import PropTypes from 'prop-types';

import { cancelArrivalSchedule } from '#/api/srm/purchaseOrder/arrivalSchedule/cancel';
import { cn } from '#/lib/utils';
import { toast } from '#/utils/toast';

import { Button } from '#/modules/commonComponents/button';
import { DESTRUCTIVE_SOLID_BUTTON_CLASS } from '#/modules/imsMgmt/receipts/shared/destructiveSolidButtonClass';
import { getPurchaseOrderApiErrorMessage } from '#/modules/srmMgmt/purchaseOrder/helper/apiError';
import { canCancelDraftArrivalSchedule } from '#/modules/srmMgmt/purchaseOrder/helper/arrivalScheduleStatus';

const PurchaseOrderArrivalScheduleCancelCell = ({
  purchaseOrderId,
  schedule,
  onMutated,
}) => {
  const [isCancelling, setIsCancelling] = useState(false);

  if (!canCancelDraftArrivalSchedule(schedule?.status)) {
    return null;
  }

  async function handleCancel() {
    if (!purchaseOrderId || !schedule?.id || isCancelling) {
      return;
    }
    setIsCancelling(true);
    try {
      const updatedAt = schedule?.record?.updatedAt ?? schedule?.updatedAt;
      await cancelArrivalSchedule(
        purchaseOrderId,
        schedule.id,
        updatedAt ? { updatedAt } : {},
      );
      toast.success('已取消排程');
      await onMutated?.();
    } catch (error) {
      toast.error(getPurchaseOrderApiErrorMessage(error, '取消排程失敗'));
    } finally {
      setIsCancelling(false);
    }
  }

  return (
    <Button
      type="button"
      size="sm"
      variant="destructive"
      className={cn(DESTRUCTIVE_SOLID_BUTTON_CLASS, 'h-7')}
      disabled={isCancelling}
      onClick={handleCancel}
    >
      {isCancelling ? '取消中…' : '取消'}
    </Button>
  );
};

PurchaseOrderArrivalScheduleCancelCell.propTypes = {
  purchaseOrderId: PropTypes.string,
  schedule: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    updatedAt: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
  }),
  onMutated: PropTypes.func,
};

export default PurchaseOrderArrivalScheduleCancelCell;
